var exports = {
  "P": "xae11d333--bdf322--location-button",
};

module.exports = exports;
